/**
 * Secciones de "Mi Bóveda" en el menú del chip de usuario.
 *
 * El tema tenía su propia lista de tres links: una cuarta puerta a la bóveda,
 * distinta de la del chip de la app, la sidebar y el drawer móvil. Ahora pide
 * las secciones reales a cards.the-vault.mx/api/nav/account, que las devuelve
 * del mismo registro (ADR 147 de CardVault) ya filtradas por el rol del usuario.
 *
 * El objetivo es que este menú se vea y se comporte como el panel del chip en
 * la app: mismos iconos (los de lucide, copiados de la librería real), misma
 * jerarquía de grupos y el mismo orden.
 *
 * La petición va con credenciales: the-vault.mx y cards.the-vault.mx son el
 * mismo sitio, así que la cookie de sesión viaja. Si algo falla, se quedan los
 * links de respaldo que ya venían en el Liquid.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://cards.the-vault.mx/api/nav/account';
  var PREFIJO_VALIDO = 'https://cards.the-vault.mx/';
  /* La tienda misma también es destino válido: "Carritos Guardados" (ADR 251
     de CardVault) lleva a the-vault.mx/cart, donde se ven y se gestionan. */
  var PREFIJOS_VALIDOS = [PREFIJO_VALIDO, 'https://the-vault.mx/'];

  // Trazos exactos de lucide-react, los mismos componentes que usa la app.
  var ICONOS = {
    LayoutDashboard:
      '<rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/>',
    Library: '<path d="m16 6 4 14"/><path d="M12 6v14"/><path d="M8 8v12"/><path d="M4 4v16"/>',
    Gavel:
      '<path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/>',
    Wallet:
      '<path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/>',
    Package:
      '<path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"/><path d="m7.5 4.27 9 5.15"/>',
    Heart:
      '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>',
    // ADR 263 (CardVault): "Mis grupos".
    Users:
      '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
    // ADR 251 (CardVault): "Carritos guardados".
    ShoppingBag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    Settings:
      '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
    LayoutPanelTop:
      '<rect width="18" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/>',
    ShieldCheck:
      '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
    Megaphone: '<path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>',
    Circle: '<circle cx="12" cy="12" r="10"/>',
    // Los de la sidebar de escritorio (ADR 260 de CardVault): los mismos que
    // usan AffiliateSidebarCard y DashboardNav.
    ArrowRight: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    HelpCircle: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
    QrCode:
      '<rect width="5" height="5" x="3" y="3" rx="1"/><rect width="5" height="5" x="16" y="3" rx="1"/><rect width="5" height="5" x="3" y="16" rx="1"/><path d="M21 16h-3a2 2 0 0 0-2 2v3"/><path d="M21 21v.01"/><path d="M12 7v3a2 2 0 0 1-2 2H7"/><path d="M3 12h.01"/><path d="M12 3h.01"/><path d="M12 16v.01"/><path d="M16 12h1"/><path d="M21 12v.01"/><path d="M12 21v-1"/>',
  };

  /** SVG con los mismos atributos que rinde lucide-react. */
  function icono(nombre) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'header__auth-vault-icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    // Trazos de una tabla fija del propio script, no de la respuesta remota.
    svg.innerHTML = ICONOS[nombre] || ICONOS.Circle;
    return svg;
  }

  /**
   * Pinta el mismo árbol en los dos contenedores. El de escritorio es el
   * dropdown del chip; el móvil es la lista dentro del drawer, con filas más
   * altas — igual que la pestaña "Mi Bóveda" del drawer de la app.
   */
  /**
   * Pastilla con un número. Mismas variantes que los badges de la app: azul
   * sólido para pedidos en curso, verde con punto para "disponibles ahora" y
   * neutra para el total. El verde dice estado; el neutro, cantidad.
   */
  function pastilla(valor, variante, titulo) {
    var span = document.createElement('span');
    span.className = 'vault-badge vault-badge--' + variante;
    span.title = titulo;
    if (variante === 'disponible') {
      var punto = document.createElement('i');
      punto.className = 'vault-badge__punto';
      span.appendChild(punto);
    }
    span.appendChild(document.createTextNode(String(valor)));
    return span;
  }

  /** Las pastillas que le tocan a una sección, según los contadores del endpoint. */
  function pastillasDe(href, contadores) {
    var salida = [];
    if (!contadores) return salida;

    if (href.indexOf('/dashboard/my-orders') !== -1 && contadores.pedidosActivos > 0) {
      salida.push(pastilla(contadores.pedidosActivos, 'pedidos',
        contadores.pedidosActivos + ' pedido' + (contadores.pedidosActivos > 1 ? 's' : '') + ' en curso'));
    }
    if (href.indexOf('/dashboard/wishlist') !== -1) {
      if (contadores.wishlistDisponibles > 0) {
        salida.push(pastilla(contadores.wishlistDisponibles, 'disponible',
          contadores.wishlistDisponibles + ' disponible' + (contadores.wishlistDisponibles > 1 ? 's' : '') + ' ahora en la bóveda'));
      }
      if (contadores.wishlistTotal > 0) {
        salida.push(pastilla(contadores.wishlistTotal, 'total',
          contadores.wishlistTotal + ' carta' + (contadores.wishlistTotal > 1 ? 's' : '') + ' en tu wishlist'));
      }
    }
    // Carritos guardados (ADR 251): una cantidad, no un estado — gris, como el
    // total de la wishlist. El color queda para lo que pide atención.
    if (href.indexOf(HREF_CARRITOS) === 0 && contadores.carritosGuardados > 0) {
      var n = contadores.carritosGuardados;
      salida.push(pastilla(n, 'total', n + ' carrito' + (n > 1 ? 's' : '') + ' guardado' + (n > 1 ? 's' : '')));
    }
    return salida;
  }

  var HREF_CARRITOS = 'https://the-vault.mx/cart';

  /** Las secciones que en la app viven en su propia tarjeta, con sus números. */
  var CON_CONTADOR = ['/dashboard/my-orders', '/dashboard/wishlist', HREF_CARRITOS];

  /**
   * Los puntos de aviso de la app (ADR 260 de CardVault), con sus mismos colores
   * y su mismo texto: Saldo cuando hay una venta esperando (verde en oscuro, como
   * en DashboardNav) y Configuración cuando falta algo requerido (amarillo, el
   * `warningSolid` de la app). Los manda /api/nav/account en `puntos`.
   */
  function puntoDe(href, puntos) {
    if (!puntos) return null;
    var punto = document.createElement('span');
    if (href.indexOf('/dashboard/payments') !== -1 && puntos.saldo) {
      punto.className = 'vault-punto vault-punto--saldo';
      punto.setAttribute('aria-hidden', 'true');
      return punto;
    }
    var n = Number(puntos.configuracion) || 0;
    if (href.indexOf('ajustes=') !== -1 && n > 0) {
      var texto = 'Tienes ' + n + ' ' + (n === 1 ? 'pendiente' : 'pendientes') + ' en Configuración';
      punto.className = 'vault-punto vault-punto--configuracion';
      punto.title = texto;
      var lector = document.createElement('span');
      lector.className = 'visually-hidden';
      lector.textContent = '. ' + texto;
      punto.appendChild(lector);
      return punto;
    }
    return null;
  }

  function esConContador(href) {
    return CON_CONTADOR.some(function (ruta) { return href.indexOf(ruta) !== -1; });
  }

  /**
   * La sidebar de la bóveda en escritorio (ADR 260 de CardVault): réplica de
   * DashboardNav, que es el maestro. La lista lleva las secciones menos las que
   * tienen contador (pedidos, wishlist, carritos), que bajan a su tarjeta del
   * pie junto a Comparte y Gana — el mismo reparto que la app.
   */
  function renderSidebar(mount, grupos, contadores, comparte, puntos) {
    mount.textContent = '';
    var conContador = [];
    var enlaceComparte = null;

    grupos.forEach(function (grupo) {
      if (grupo.group === 'compartir') {
        enlaceComparte = (grupo.items || [])[0] || null;
        return;
      }
      var items = (grupo.items || []).filter(function (item) {
        var href = String(item.href || '');
        if (!PREFIJOS_VALIDOS.some(function (p) { return href.indexOf(p) === 0; })) return false;
        if (href.indexOf(HREF_CARRITOS) === 0 && !(contadores && contadores.carritosGuardados > 0)) return false;
        if (esConContador(href)) {
          conContador.push(item);
          return false;
        }
        return true;
      });
      if (!items.length) return;
      if (grupo.group !== 'boveda' && grupo.label) {
        var etiqueta = document.createElement('p');
        etiqueta.className = 'vault-sidebar__grupo';
        etiqueta.textContent = grupo.label;
        mount.appendChild(etiqueta);
      }
      items.forEach(function (item) {
        var link = document.createElement('a');
        link.href = String(item.href);
        link.className = 'vault-sidebar__item';
        link.appendChild(icono(String(item.icon || 'Circle')));
        var texto = document.createElement('span');
        texto.className = 'vault-item__texto';
        texto.textContent = String(item.label || '');
        link.appendChild(texto);
        pastillasDe(String(item.href), contadores).forEach(function (p) { link.appendChild(p); });
        var puntoB = puntoDe(String(item.href), puntos); if (puntoB) link.appendChild(puntoB);
        mount.appendChild(link);
      });
    });

    var pie = document.querySelector('[data-vault-sidebar-pie]');
    if (!pie) return;
    pie.textContent = '';
    if (enlaceComparte) pie.appendChild(tarjetaComparteSidebar(enlaceComparte, comparte));
    if (conContador.length) {
      var envoltura = document.createElement('div');
      envoltura.className = 'vault-sidebar__bloque';
      var tarjeta = document.createElement('div');
      tarjeta.className = 'vault-sidebar__tarjeta';
      conContador.forEach(function (item) {
        var link = document.createElement('a');
        link.href = String(item.href);
        link.className = 'vault-sidebar__fila';
        link.appendChild(icono(String(item.icon || 'Circle')));
        var texto = document.createElement('span');
        texto.className = 'vault-item__texto';
        texto.textContent = String(item.label || '');
        link.appendChild(texto);
        pastillasDe(String(item.href), contadores).forEach(function (p) { link.appendChild(p); });
        var puntoB = puntoDe(String(item.href), puntos); if (puntoB) link.appendChild(puntoB);
        tarjeta.appendChild(link);
      });
      envoltura.appendChild(tarjeta);
      pie.appendChild(envoltura);
    }
  }

  /** Réplica de AffiliateSidebarCard: sin código, «Activar mi código»; con él, el código y su %. */
  function tarjetaComparteSidebar(item, comparte) {
    var destino = String(item.href || '');
    if (destino.indexOf(PREFIJO_VALIDO) !== 0) destino = PREFIJO_VALIDO + 'dashboard?compartir=1';
    var codigo = comparte && comparte.codigo ? String(comparte.codigo) : null;

    var envoltura = document.createElement('div');
    envoltura.className = 'vault-sidebar__bloque';
    var tarjeta = document.createElement('div');
    tarjeta.className = 'vault-sidebar__comparte';

    var cabecera = document.createElement('div');
    cabecera.className = 'vault-sidebar__comparte-cabecera';
    var marca = document.createElement('span');
    marca.className = 'vault-sidebar__comparte-icono';
    marca.appendChild(icono('Megaphone'));
    cabecera.appendChild(marca);
    var titulo = document.createElement('span');
    titulo.className = 'vault-sidebar__comparte-titulo';
    titulo.textContent = 'Comparte y Gana';
    cabecera.appendChild(titulo);
    if (codigo && comparte.tasa != null) {
      var tasa = document.createElement('span');
      tasa.className = 'vault-sidebar__comparte-tasa';
      tasa.textContent = Math.round(Number(comparte.tasa) * 100) + '%';
      cabecera.appendChild(tasa);
    }
    tarjeta.appendChild(cabecera);

    if (codigo) {
      var linea = document.createElement('p');
      linea.className = 'vault-sidebar__comparte-codigo';
      linea.textContent = codigo;
      tarjeta.appendChild(linea);
    } else {
      var texto = document.createElement('p');
      texto.className = 'vault-sidebar__comparte-texto';
      texto.textContent = 'Comparte tu código: dan 5% off y ganas cuando lo usan.';
      tarjeta.appendChild(texto);
    }

    var cta = document.createElement('a');
    cta.href = destino;
    cta.className = 'vault-sidebar__comparte-cta';
    if (codigo) {
      cta.appendChild(icono('QrCode'));
      cta.appendChild(document.createTextNode('Ver código y QR'));
    } else {
      cta.appendChild(document.createTextNode('Activar mi código'));
      cta.appendChild(icono('ArrowRight'));
    }
    tarjeta.appendChild(cta);

    var como = document.createElement('a');
    como.href = destino;
    como.className = 'vault-sidebar__comparte-como';
    como.appendChild(icono('HelpCircle'));
    como.appendChild(document.createTextNode('¿Cómo funciona?'));
    tarjeta.appendChild(como);

    envoltura.appendChild(tarjeta);
    return envoltura;
  }

  function render(mount, grupos, contadores, comparte, puntos) {
    var movil = mount.getAttribute('data-variant') === 'mobile';
    mount.textContent = '';

    // En móvil, pedidos y wishlist salen de la lista y bajan a su tarjeta, igual
    // que en la sidebar y el drawer de la app: son estado, no secciones.
    var conContador = [];

    grupos.forEach(function (grupo) {
      // El primer grupo no lleva etiqueta: el chip ya dice de qué va. En móvil
      // tampoco la lleva Comparte y Gana: ahí es una tarjeta con su propio
      // título, y el encabezado quedaba diciendo lo mismo dos veces.
      if (grupo.group !== 'boveda' && grupo.label && !(movil && grupo.group === 'compartir')) {
        var etiqueta = document.createElement('p');
        etiqueta.className = 'header__auth-vault-group';
        etiqueta.textContent = grupo.label;
        mount.appendChild(etiqueta);
      }

      (grupo.items || []).forEach(function (item) {
        var href = String(item.href || '');
        if (!PREFIJOS_VALIDOS.some(function (p) { return href.indexOf(p) === 0; })) return;
        // Sin carritos guardados la fila no lleva a nada: no se pinta (igual que en la app).
        if (href.indexOf(HREF_CARRITOS) === 0 && !(contadores && contadores.carritosGuardados > 0)) return;

        if (movil && grupo.group === 'compartir') {
          // La misma tarjeta que la app pone en su drawer (AffiliateSidebarCard),
          // sin la envoltura de la sidebar: el drawer ya trae su margen.
          mount.appendChild(tarjetaComparteSidebar(item, comparte).firstChild);
          return;
        }

        if (movil && esConContador(href)) {
          conContador.push(item);
          return;
        }

        var link = document.createElement('a');
        link.href = href;
        link.setAttribute('role', 'menuitem');
        if (movil) link.className = 'header__auth-vault-mobile-item';
        link.appendChild(icono(String(item.icon || 'Circle')));

        var texto = document.createElement('span');
        texto.className = 'vault-item__texto';
        texto.textContent = String(item.label || '');
        link.appendChild(texto);

        pastillasDe(href, contadores).forEach(function (p) { link.appendChild(p); });
        var puntoA = puntoDe(href, puntos); if (puntoA) link.appendChild(puntoA);

        mount.appendChild(link);
      });
    });

    if (movil && conContador.length) {
      var tarjeta = document.createElement('div');
      tarjeta.className = 'vault-tarjeta';
      conContador.forEach(function (item) {
        var link = document.createElement('a');
        link.href = item.href;
        link.className = 'header__auth-vault-mobile-item';
        var svgIcono = icono(String(item.icon || 'Circle'));
        // El corazón de la wishlist va relleno y en color de "me gusta": es lo que
        // ya guardaste, no una acción por hacer. Igual que en la app.
        if (String(item.icon) === 'Heart') svgIcono.classList.add('vault-icono--like');
        link.appendChild(svgIcono);
        var texto = document.createElement('span');
        texto.className = 'vault-item__texto';
        texto.textContent = String(item.label || '');
        link.appendChild(texto);
        pastillasDe(String(item.href), contadores).forEach(function (p) { link.appendChild(p); });
        var puntoB = puntoDe(String(item.href), puntos); if (puntoB) link.appendChild(puntoB);
        tarjeta.appendChild(link);
      });
      mount.appendChild(tarjeta);
    }

    if (movil) mount.style.display = '';
  }

  function init() {
    var mounts = document.querySelectorAll('[data-vault-account-nav]');
    if (mounts.length === 0) return;

    fetch(ENDPOINT, { credentials: 'include' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var grupos = (data && data.grupos) || [];
        if (grupos.length === 0) return;
        // Los contadores son opcionales: si el endpoint no los manda —o tardaron
        // más de lo que él espera— las secciones se pintan igual, sin pastilla.
        var contadores = (data && data.contadores) || null;
        var comparte = (data && data.comparte) || null;
        var puntos = (data && data.puntos) || null;
        mounts.forEach(function (mount) {
          if (mount.getAttribute('data-variant') === 'sidebar') renderSidebar(mount, grupos, contadores, comparte, puntos);
          else render(mount, grupos, contadores, comparte, puntos);
        });
        // La firma de la sidebar lleva la versión de la app, como en DashboardNav.
        var version = data && data.version ? String(data.version) : '';
        document.querySelectorAll('[data-vault-version]').forEach(function (el) {
          el.textContent = version ? 'v' + version : 'Novedades';
        });
      })
      .catch(function () {
        /* se quedan los links de respaldo */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Crear, duplicar o borrar un carrito guardado en /cart cambia el contador
  // (y si la fila se muestra): se vuelve a pedir el menú sin recargar la página.
  document.addEventListener('vault:carritos-guardados-cambiaron', init);
})();
